module.exports = __webpack_public_path__ + "img/scene_plants_growth_big@2x.99eded35.png";